import draftService from '@/app-domains/messages/draft/writing.service'
import { InlineInput } from '@/components/InlineInput/InlineInput'
import { useEffect, useState } from 'react'

import './styles.scoped.sass'

export default function SubjectSection (props) {
  const [toInputValue, setToInputValue] = useState('')

  useEffect(() => {
    setToInputValue(props.subject || '')
  }, [props.subject])

  const onChangeHandler = async (e) => {
    const subject = e.target.value
    setToInputValue(subject)
    await draftService.setSubject(subject)
  }
  const onKeyDownHandler = () => {}

  return (
    <div className='subject-section'>
      <InlineInput
        placeholder='Subject'
        value={toInputValue}
        onInput={onChangeHandler}
        onKeyDown={onKeyDownHandler}
        fullWidth={true}
      />
    </div>
  )
}
